import { isServer } from 'lib/utils'
import { ParsedUrlQuery } from 'querystring'

import removeParamFromURL from '../lib/removeParamFromURL'
import useEffectOnce from './useEffectOnce'
import useRouter from './useRouter'

// eslint-disable-next-line no-shadow
enum VisitorType {
  BUYER = 'BUYER',
  RECIPIENT = 'RECIPIENT',
}

type VisitorTypeProps = {
  isBuyer: boolean
  isRecipient: boolean
}

function resolveTypeFrom(query: ParsedUrlQuery): VisitorType {
  return 'asBuyer' in query ? VisitorType.BUYER : VisitorType.RECIPIENT
}

export default function useVisitorType(): VisitorTypeProps {
  const router = useRouter()
  const sessionVisitorType =
    !isServer() && window.sessionStorage.getItem('visitorType')

  const visitorType = sessionVisitorType || resolveTypeFrom(router.query)

  useEffectOnce(() => {
    if (visitorType === VisitorType.BUYER) {
      router.replace(removeParamFromURL(router.asPath, 'asBuyer'), undefined, {
        shallow: true,
        localize: false,
      })
    }

    if (!isServer()) {
      window.sessionStorage.setItem('visitorType', visitorType)
    }
  })

  return {
    isBuyer: visitorType === VisitorType.BUYER,
    isRecipient: visitorType === VisitorType.RECIPIENT,
  }
}
